import $ from "jquery";
import { addAction } from "@bd-core/bd-hooks";
import CONFIG from "@bd-core/config";
import counterUp from "counterup2";

export const AlgoritmExperience = () => {
	if (CONFIG.siteSetup !== "algoritm-experience") return;

	addAction("result:after-render", () => {
		const $roundScore = $(".roundScore");
		const $totalScore = $(".total-score");
		const $algorithmScore = $(".algorithm-score");
		let totalScoreAlgo = 0;

		$roundScore.each(function () {
			counterUp($(this)[0], {
				duration: 100,
				delay: 1,
			});
		});

		//count total algorithm-points based on algorithm-score
		$algorithmScore.each(function () {
			const $self = $(this);
			totalScoreAlgo += $self.data("score");
		});

		$totalScore.each(function () {
			const $this = $(this)[0];
			const $self = $(this);
			setTimeout(function () {
				$self.parent().removeClass("invisible");

				//count total algorithm-points based on algorithm-score
				if ($self.hasClass("algorithm-points")) {
					$self.html(totalScoreAlgo.toString());
					$self.attr("data-score", totalScoreAlgo);
				}

				counterUp($this, {
					duration: 500,
					delay: 1,
				});
			}, 1000);
		});
	});
};
